<template>
    <v-snackbar v-model="snack_state" :timeout="snackbar_options.timeout" :color="snackbar_options.color" bottom left>
      <v-icon v-if="snackbar_options.show_icon" left :color=snackbar_options.icon_color size="20">{{ snackbar_options.icon }}</v-icon>
      <span :class="snackbar_options.text_color + '--text'">{{ snackbar_options.text }}</span>
        <v-btn
            v-if="snackbar_options.action && snackbar_options.action_text"
            :color="snackbar_options.text_color"
            text
            @click="snackbar_options.action"
        >
            {{ snackbar_options.action_text }}
        </v-btn>
        <v-btn v-if="snackbar_options.close_text" :color="snackbar_options.text_color" text @click="closeSnackBar">
            {{ snackbar_options.close_text }}
        </v-btn>
    </v-snackbar>
</template>
<script>
import { computed } from "@vue/composition-api";
import DialogModule from "../store/modules/dialog";

export default {
    name: "SnackBar",
    setup() {
        const { snackbar_options, snackbar_open, setSnackBar, closeSnackBar } = DialogModule();
        const snack_state = computed({
            get: () => snackbar_open.value,
            set: val => {
                setSnackBar(val);
            }
        });
        return {
            snack_state,
            snackbar_options,
            closeSnackBar
        };
    }
};
</script>
